import { formatINR, resolveFinishRateV2 } from "@/lib/quotationApi";

const tierTotalSizeClass = (rank) =>
  rank === 0
    ? "text-4xl sm:text-5xl"
    : rank === 1
      ? "text-3xl sm:text-4xl"
      : "text-2xl sm:text-3xl";

export default function PublicTierTotals({ sortedTierList, tierList, effectiveQ, excluded, breakdown }) {
  const b = breakdown;
  return (
    <div className="space-y-3 mb-5" data-testid="public-tier-totals">
      {sortedTierList.map((t, idx) => {
        // Distinct finishes used in the quote with their per-tier rate
        // (cascade: blank tier inherits from the tier above, up to base).
        const finishRates = (() => {
          const seen = new Map();
          (effectiveQ.rooms || []).forEach((room) => {
            (room.measurements || []).forEach((m) => {
              if (excluded.has(m.id)) return;
              if (!m.finish_id || !m.finish_name) return;
              if (seen.has(m.finish_id)) return;
              const rate = resolveFinishRateV2(m, t, tierList, t.finish_discount);
              seen.set(m.finish_id, { name: m.finish_name, rate });
            });
          });
          return Array.from(seen.values());
        })();
        return (
          <div
            key={t.id}
            className="relative overflow-hidden rounded-2xl border p-5"
            style={{
              borderColor: `${t.color}66`,
              background: `linear-gradient(135deg, ${t.color}22, rgba(255,255,255,0.01) 70%)`,
            }}
            data-testid={`public-tier-${t.id}`}
          >
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <div className="overline" style={{ color: t.color }}>
                    {t.name}
                  </div>
                </div>
                {t.description && (
                  <div className="text-[11px] text-white/55 leading-snug">
                    {t.description}
                  </div>
                )}
                {finishRates.length > 0 && (
                  <div
                    className="mt-2 flex flex-wrap gap-1.5"
                    data-testid={`public-tier-finish-rates-${t.id}`}
                  >
                    {finishRates.map((fr) => (
                      <span
                        key={fr.name}
                        className="text-[10px] px-1.5 py-0.5 rounded-full border inline-flex items-center gap-1"
                        style={{
                          borderColor: `${t.color}44`,
                          color: `${t.color}cc`,
                        }}
                      >
                        <span className="text-white/70">{fr.name}</span>
                        <span>{formatINR(fr.rate)}</span>
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div
                className={`font-display font-bold leading-none ${tierTotalSizeClass(idx)}`}
                style={{ color: t.color }}
                data-testid={`public-tier-total-${t.id}`}
              >
                {formatINR(t.breakdown.grand_total)}
              </div>
            </div>
          </div>
        );
      })}
      {(b.discount > 0 || b.taxPct > 0) && (
        <div className="text-[11px] text-white/40 text-right space-x-3">
          {b.discount > 0 && <span>Discount −{formatINR(b.discount)}</span>}
          {b.taxPct > 0 && <span>Tax {b.taxPct}%</span>}
        </div>
      )}
    </div>
  );
}
